import React, { useEffect, useState } from 'react'
import SocialMedia from '../../component/SocialMedia/socialMedia'
import { FaAward } from 'react-icons/fa'

const certificates = [
  { id: 1, title: 'Front-End Development', issuer: 'FreeCodeCamp', date: '2023', link: '#' },
  { id: 2, title: 'React - The Complete Guide', issuer: 'Udemy', date: '2022', link: '#' },
  { id: 3, title: 'JavaScript Algorithms', issuer: 'Codecademy', date: '2021', link: '#' },
]
// udemy, aws cloud practitioner, mosh, stuff on linkdin learning

// workHistory moved to src/data/workHistory.js and imported above

function Certificates() {
  const [scrollY, setScrollY] = useState(0)

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY)
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <div style={{ fontFamily: "'Roboto', sans-serif", margin: 0, padding: 0 }}>
      {/* Hero */}
      <section style={{ height: '48vh', minHeight: 360, display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center', background: 'linear-gradient(135deg, #667eea, #764ba2)', color: '#fff', padding: '0 20px', opacity: scrollY < 80 ? 1 : 0.95, transition: 'opacity 0.6s ease' }}>
        <div>
          <FaAward style={{ fontSize: 48, marginBottom: 10 }} />
          <h1 style={{ fontSize: '40px', fontWeight: 700, margin: '6px 0 12px', transform: `translateY(${scrollY * 0.05}px)`, transition: 'transform 0.3s ease-out' }}>Certificates</h1>
          <p style={{ fontSize: '18px', maxWidth: 820, margin: '0 auto', lineHeight: 1.6 }}>Certifications and professional courses that demonstrate my continuous learning and technical competence.</p>
        </div>
      </section>

      <main style={{ maxWidth: '1000px', margin: '0 auto', padding: '80px 20px 60px 20px' }}>
        <section style={{ marginBottom: '40px' }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '18px' }}>
            {certificates.map((c) => (
              <article key={c.id} style={{ padding: 18, borderRadius: 10, background: '#fff', boxShadow: '0 6px 18px rgba(0,0,0,0.06)' }}>
                <h3 style={{ margin: '0 0 6px' }}>{c.title}</h3>
                <p style={{ margin: 0, color: '#666' }}>{c.issuer} • {c.date}</p>
                <div style={{ marginTop: 12 }}>
                  <a href={c.link} style={{ color: '#667eea', textDecoration: 'none', fontWeight: 700 }}>View certificate</a>
                </div>
              </article>
            ))}
          </div>
        </section>

        <section style={{ marginBottom: '40px' }}>
          <h2 style={{ fontSize: '26px', borderBottom: '3px solid #667eea', display: 'inline-block', paddingBottom: '6px', color: '#333', marginBottom: '18px' }}>Certificates History</h2>
          <div style={{ display: 'grid', gap: '14px', marginTop: 16 }}>
            {certificates.map((c) => (
              <div key={c.id} style={{ display: 'grid', gridTemplateColumns: '120px 1fr', gap: 12, alignItems: 'start', padding: 14, background: '#fff', borderRadius: 10, boxShadow: '0 6px 18px rgba(0,0,0,0.06)' }}>
                <div style={{ color: '#667eea', fontWeight: 700 }}>{c.date}</div>
                <div>
                  <h4 style={{ margin: '0 0 6px' }}>{c.title} <span style={{ color: '#555', fontWeight: 600 }}>• {c.issuer}</span></h4>
                  <p style={{ margin: 0, color: '#666' }}>Issued {c.date}</p>
                  <div style={{ marginTop: 8 }}><a href={c.link} style={{ color: '#667eea', textDecoration: 'none', fontWeight: 700 }}>View certificate</a></div>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section style={{ marginTop: 30, textAlign: 'center' }}>
          <h2 style={{ fontSize: '26px', borderBottom: '3px solid #667eea', display: 'inline-block', paddingBottom: '6px', color: '#333', marginBottom: '18px' }}>More about learning</h2>
          <p style={{ color: '#555' }}>I'm always learning—check my LinkedIn or GitHub for updates on recent courses and achievements.</p>

          <SocialMedia links={[{ label: 'GitHub', url: 'https://github.com/' }, { label: 'LinkedIn', url: 'https://linkedin.com/' }]} size={44} />
        </section>
      </main>

    </div>
  )
}

export default Certificates
